import React, { useCallback } from 'react';
// import { gsap } from 'gsap';
// import { useConfigMC } from '~/store/Query/api';
import useStores from '~/store/StoreHook';
// import { usePospagoState } from '~/store/States/pospago';

const CheckoutSteps = ({ active }) => {
  // const config = useConfigMC();
  const { orderStore } = useStores();
  // const pospagoState = usePospagoState();

  const ref = useCallback((node) => {
    if (node) {
      import('gsap').then((module) => {
        const { gsap } = module;
        const tl = gsap.timeline();
        const line = ('.line-progress');
        const total = document.querySelectorAll('.checkout--steps li').length - 1;
        const step = document.querySelectorAll('.checkout--steps .active').length - 1;
        tl.to(line, { duration: 0.3, overwrite: 'auto', width: `${((step / total) * 100).toFixed()}%` });
      });
    }
  }, []);

  if (!orderStore.getCartInfo?.data?.data?.items?.length/* || !config.data?.ok*/) {
    return null;
  }

  // const kit = orderStore.getCartInfo.data.data.items.find(item => !!item.part_number_kit);
  // let infoContrato;
  // if (kit) {
  //   const typePospago = kit.part_number === pospagoState.config.product_sku_sin_equipo.value ? 'S' : 'C';
  //   infoContrato = config.data.body.contratos[typePospago === 'S' ? 'sin_equipo' : 'con_equipo'];
  // }
  let step = 0;

  return (
    <div className="checkout--steps" ref={ref}>
      <div className="module">
        <ul>
          <li className={`step${step += 1} ${active >= step ? 'active' : ''}`}>
            <span />
            <p>Datos personales</p>
          </li>
          <li className={`step${step += 1} ${active >= step ? 'active' : ''}`}>
            <span />
            <p>Datos de envío</p>
          </li>
          {/*{kit && (*/}
          {/*  <li className={`step${step += 1} ${active >= step ? 'active' : ''}`}>*/}
          {/*    <span />*/}
          {/*    <p>{infoContrato.paso}</p>*/}
          {/*  </li>*/}
          {/*)}*/}
          <li className={`step${step += 1} ${active >= step ? 'active' : ''}`}>
            <span />
            <p>Forma de pago</p>
          </li>
        </ul>
        <div className="line">
          <div className="line-border" />
          <div className="line-progress" />
        </div>
      </div>
    </div>
  );
};

export default CheckoutSteps;
